<template>
  <v-container>
    <v-flex>
      <v-data-iterator 
        :items="richiesteVerificate" 
        row
        wrap
        class="elevation-0"
        content-class="v-list--two-line"
        content-tag="v-list">
        <v-flex
          slot="no-data"
          align-self-center
          class="title font-weight-light grey--text pa-3 text-xs-center"
        >Non ci sono richieste!</v-flex>
        <template slot="item" slot-scope="props">
          <v-list-tile>
            <v-list-tile-content class="px-2">
              <div class="body-2 font-weight-medium">{{props.item.nominativo}} - {{props.item.causale}}</div>
              <div class="body-1">
                <template v-for="(item,i) in creaIcone(props.item.categorie)">
                  <div :key="i" class="px-2" style="display: inline-grid;">
                    <v-icon
                      size="14"
                      color="#01579b"
                      style="padding:0 5px 0 5px;"
                    >{{ item.icon }}</v-icon>
                    <span class="caption tree--text">{{item.descrizione}}</span>                      
                  </div>
                </template>
              </div>
              <v-divider class="my-1" style="width: 100%"></v-divider>
            </v-list-tile-content>
            <v-list-tile-action class="align-center">
              <div class="caption font-weight-regular">{{ dataFormat(props.item.data) }}</div>
              <v-icon v-if="props.item.stato == 1" color="green">check</v-icon>
              <v-icon v-else color="error">fas fa-times</v-icon>
            </v-list-tile-action>
          </v-list-tile>
        </template>
      </v-data-iterator>
    </v-flex>

    <v-dialog v-model="dialog" max-width="500px" persistent>
      <v-card>
        <v-flex v-if=" conferma == true">
          <v-toolbar color="secondary" dense>
            <v-toolbar-title class="primarytext--text">Accetta richiesta</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-card-title
              style="font-size: 17px;"
            >Inserisci le categorie per poter confermare {{singleElement.nominativo}}</v-card-title>

            <v-select
              :items="categorie"
              item-text="descrizione"
              item-value="id"
              multiple
              clearable
              color="tree"
              label="Categorie"
              v-model="categorie_scelte"
            ></v-select>

            <v-btn color="error" dark @click="chiudiHandler">Chiudi</v-btn>
            <v-btn color="secondary" :disabled="!attiva" dark @click="confermaHandler">Salva</v-btn>
          </v-card-text>
        </v-flex>
        <v-flex v-if=" elimina == true">
          <v-toolbar color="secondary" dense>
            <v-toolbar-title class="primarytext--text">Elimina Richiesta</v-toolbar-title>
            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <v-card-title
              style="font-size: 17px;"
            >Sei sicuro di voler eliminare la richiesta di {{singleElement.login}}?</v-card-title>

            <v-btn color="error" dark @click="chiudiHandler">Chiudi</v-btn>
            <v-btn color="secondary" dark @click="eliminaHandler(singleElement.login)">Elimina</v-btn>
          </v-card-text>
        </v-flex>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
export default {
  name: "tab-richieste",
  components: {},
  props: {
    richiesteVerificate: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      tabs: "richieste",
      categorie_scelte: [],
      dialog: false,
      conferma: false,
      elimina: false,
      singleElement: {},
      pagination: {
        sortBy: 'data',
        descending: true
      },
      headers: [
        {
          text: "NOMINATIVO",
          width: '200px',
          sortable: true,
          value: "nominativo"
        },
        {
          text: "DATA",
          width: '150px',
          sortable: true,
          value: "data"
        },
        {
          text: "CAUSALE",
          sortable: false,
          value: "categorie"
        },
        {
          text: "CATEGORIE",
          sortable: false,
          width: '250px',
          value: "categorie"
        },
        {
          text: "STATO",
          sortable: false,
          value: ""
        }
      ]
    };
  },
  computed: {
    categorie() {
      return this.$store.getters.getPageData.categorieSpese;
    },
    nomi_categorie: {
      get() {
        return this.singleElement.categorie
          ? this.singleElement.categorie.split(",")
          : [];
      },
      set(val) {
        this.singleElement.categorie = val.join(",");
      }
    },
    attiva() {
      if (this.categorie_scelte.length > 0) {
        return true;
      } else return false;
    }
  },
  created() {
  },
  beforeCreate() {
    if (!this.$store.hasModule("gestione")) {
      this.$store.registerModule("gestione", GestioneAdmin);
    }
  },
  methods: {
    creaIcone(vettore) {
      return this.categorie
        .filter(ct => {
          return vettore && vettore.split(",").includes(ct.id);
        })
        // .map(ct => ct.icon);
    },
    selezionaIcone(categorie) {
      var s = [];
      for (var i = 0; i < categorie.length; i++) {
        if (v[i] == this.categorie[j].id) {
          s.push(categorie[i].icon);
        }
      }
      return s;
    },
    accettaRichiestaHandler(item) {
      this.singleElement = item;
      this.elimina = false;
      this.dialog = true;
      this.conferma = true;
    },
    rifiutaRichiestaHandler(item) {
      this.singleElement = item;
      this.conferma = false;
      this.dialog = true;
      this.elimina = true;
    },
    confermaHandler() {
      this.dialog = false;
      this.conferma = false;
    },
    eliminaHandler() {
      this.dialog = false;
      this.elimina = false;
    },
    dataFormat(data) {
      return !data ? data : this.$moment(data).format("DD/MM/YYYY");
    },
    chiudiHandler(data) {
      this.singleElement = {};
      this.categorie_scelte = [];
      this.dialog = false;
    }
  }
};
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/TabStorico.vue